import React, { useContext } from "react"
import sagyouin from "../../source/img/takuhai_truck_man.png"
import { useSelector } from "react-redux"
import { RootState } from "../../globalStore/rootreducer"
import { CSS_PROPERTY } from "../../features/Tablet/cssProperties/tablet"
import {
  TenkoHeaderContext,
  TenkoKubunContext,
  ZyomuinContext,
} from "../../features/Tablet/context/context"
import { useHistory, useLocation } from "react-router-dom"
import {
  selectTenkoBasyoPage,
  selectTenkoTimingPage,
  selectTenkoTypePage,
} from "../../constant/tablet/pages"
import dayjs from "dayjs"

const ZyomuinInfo: React.FC<{ children?: React.ReactNode }> = React.memo(
  ({ children }) => {
    const history = useHistory()
    const location = useLocation()
    const { LoginUserInfo: userInfo } = useSelector(
      (state: RootState) => state.user
    )
    const { 乗務員 } = useContext(ZyomuinContext)
    const { 点呼区分 } = useContext(TenkoKubunContext)
    const { 点呼ヘッダ情報 } = useContext(TenkoHeaderContext)

    const move乗務員選択: React.TouchEventHandler<HTMLDivElement> = (e) => {
      e.preventDefault()
      e.stopPropagation()

      history.push(selectTenkoTypePage.Route.path)
    }

    return (
      <table
        className="w-100"
        style={{
          height: "6rem",
          visibility: userInfo.社員ID ? "visible" : "hidden",
          padding: "0 !important",
          tableLayout: "fixed",
        }}>
        <tbody>
          <tr
            style={{
              padding: "0 !important",
            }}>
            <td
              style={{
                justifyContent: "space-between",
                display: "flex",
                alignItems: "center",
                padding: "0 !important",
              }}>
              {children != null ? (
                children
              ) : (
                <table
                  className="me-4 d-inline-block"
                  style={{ height: "100%" }}>
                  <tbody>
                    <tr>
                      <td className="text-start">
                        <table
                          className="w-100"
                          style={{ tableLayout: "auto" }}>
                          <tbody>
                            <tr style={{ fontSize: "2rem" }}>
                              {点呼ヘッダ情報 && (
                                <td className="text-start">
                                  点呼日:
                                  {dayjs(点呼ヘッダ情報.点呼日).format(
                                    "MM/DD (ddd)"
                                  )}
                                </td>
                              )}
                            </tr>
                            <tr style={{ fontSize: "4rem" }}>
                              {点呼区分 && (
                                <td className="text-start">{点呼区分.名称1}</td>
                              )}
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
              {/* 点呼時刻選択と点呼場所以外のとき表示する */}
              {![
                selectTenkoTimingPage.Route.path,
                selectTenkoBasyoPage.Route.path,
              ].some((e) => e === location.pathname) && (
                <div
                  onTouchStart={move乗務員選択}
                  style={{
                    display: "inline-block",
                    right: "0",
                    width: "fit-content",
                    fontSize: "2rem",
                    margin: "1.1rem 0 0 0",
                    backgroundColor: "white",
                    verticalAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    padding: "2.3rem 2rem",
                  }}>
                  乗務員選択に戻る
                </div>
              )}
            </td>
            <td
              className="text-end"
              style={{
                padding: "0 !important",
                width: "40%",
              }}>
              <table className="me-4 d-inline-block" style={{ height: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <div
                        className="text-center"
                        style={{
                          height: "8rem",
                          width: "8rem",
                          margin: "1rem",
                          padding: "1rem 1rem 1rem 1rem",
                          ...CSS_PROPERTY.BORER_PROPERTIES,
                          backgroundColor: "white",
                        }}>
                        <img
                          src={sagyouin}
                          style={{
                            height: "6rem",
                            width: "auto",
                          }}
                          alt=""></img>
                      </div>
                    </td>
                    <td
                      className="text-start w-25rem"
                      style={{ fontSize: "2.5rem" }}>
                      <table>
                        <tbody>
                          <tr>
                            <td className="text-end">{乗務員?.部所コード}</td>
                            <td>:</td>
                            <td className="text-start">{乗務員?.部所略称}</td>
                          </tr>
                          <tr>
                            <td className="text-end">{乗務員?.社員コード}</td>
                            <td>:</td>
                            <td className="text-start">{乗務員?.社員氏名}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
)

export default ZyomuinInfo
